// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ocWL","modalFooterButton":"ModalNotes_modalFooterButton__3TeIq"};